<template>
  <div class="coursesPage font-17">
    <Loading :loading="isLoading"></Loading>
    <topNav />
    
    <b-row class="justify-content-md-center mb-10">
      <b-col lg="2" xl="2" class="layout-side-menu px-0 ">
        <sideMenu />
      </b-col>
      <b-col lg="10" xl="10" class="layout-content mt-5 ">
        <b-row>
          <b-col>
            <p style="font-size: 24px" class="pl-10">
              <b> {{ title }}</b>
            </p>
          </b-col>
        </b-row>
        <b-row v-if="ebooks.length > 0" 
          align-v="stretch"
          class="mx-3  mx-sm-0 ml-sm-0 px-sm-3"
        >
          <b-col 
          
          sm="6" md="6" lg="6" xl="3" xxl="3" 
           v-for="view in ebooks" :key="view.id" 
           class="subject-card my-2 mb-10 px-0 px-sm-2"
          >
            <div class="book-cover">
              <b-card-group>
                <b-card overlay :img-src="view.image" img-alt="Image" img-top img-height="auto"></b-card>
              </b-card-group>
            </div>
            <div class="margin book-actions">
              <b-button class="btn-book-read" @click="getFlipbook(view.id)">
                <b-icon icon="book"></b-icon>&nbsp;&nbsp;{{ readLabel(view) }}
              </b-button>
              <b-button
                v-if="canDownload(view)"
                class="btn-book-download"
                @click="downloadBook(view.id)"
              >
                <b-icon icon="download"></b-icon>&nbsp;&nbsp;ดาวน์โหลด
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mb-10">
      <!-- <b-col class="col-xs-1"></b-col> -->
      <b-col>
        <b-pagination class="justify-content-md-end justify-content-sm-center justify-content-center mx-10 p-0"  v-model="paginate.current_page" :total-rows="paginate.total"
          :per-page="paginate.per_page" aria-controls="my-table" @input="getElibrary()"></b-pagination>  
      </b-col>
      <!-- <b-col class="col-xs-1"></b-col> -->
    </b-row>

    <div id="myModal" class="modal" v-show="dialog">
      <!-- Modal content -->
      <div class="modal-content">
        <span class="close" @click="dialog = false">&times;</span>
        <div v-show="!coverOnly" class="flip-book-container solid-container"></div>
        <div v-if="coverOnly" class="cover-only-container">
          <img :src="coverImage" alt="ภาพหน้าปก" class="cover-only-image" />
          <p class="cover-only-note">
            ไฟล์ .zip จึงอ่านออนไลน์ไม่ได้
            <span v-if="coverDownloadable">กรุณากดปุ่มดาวน์โหลดเพื่อเปิดอ่าน</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import topNav from "@/components/topNav.vue";
// import sideMenuMobile from "@/components/sideMenuMobile.vue";
// import sideMenu from "@/components/sideMenu.vue";
import { mapState } from "vuex";
import sideMenu from "@/components/sideMenu.vue";
import Loading from "@/components/Loading.vue";
import GroupAPI from "../service/api/GroupAPI";
import { imageDomain } from "../util/Constants"
import router from "../router";

export default {
  name: "ebookPage",
  components: {
    topNav,
    // sideMenuMobile,
    sideMenu,
    Loading,
  },
  computed: {
    ...mapState({
      menus: (state) => {
        return state.Courses.menus;
      },
      userData: (state) => state.Auth.userData,
    }),
  },
  async mounted() {
    if (this.$router.currentRoute.query.id == '1' && !this.userData.id) {
      alert("กรุณา Login");
      router.push({ path: "/login" })
    }
    this.isLoading = true;
    await this.getElibrary();
    await this.getBookBanner();
    this.isLoading = false;
  },
  data() {
    return {
      filterid: "",
      isLoading: false,
      ebooks: [],
      title: "รายการ",
      ebooksDefault: [],
      banners: [],
      paginate: {
        current_page: 1,
        total: 1,
        per_page: 1,
      },
      hoverid: null,
      dialog: false,
      imageDomain,
      slide:null,
      // หนังสือที่แนบเป็นไฟล์ .zip อ่านออนไลน์ไม่ได้ เปิดมาแล้วเห็นแค่ภาพหน้าปก
      coverOnly: false,
      coverImage: null,
      coverDownloadable: true
    };
  },
  methods: {
    async getBookBanner() {
      this.banners = await GroupAPI.getBookBanner();
    },
    async getElibrary() {
      const res = await GroupAPI.getElibrary({
        groupid: this.$router.currentRoute.query.id,
        page: this.paginate.current_page,
        filterid: this.filterid,
      });
      this.ebooks = res.data;
      this.paginate = {
        current_page: res.current_page,
        total: res.total,
        per_page: res.per_page,
      };

      this.ebooksDefault = this.ebooks;
    }, 
    async getFavoriteBook(page) {
      const res = await GroupAPI.getFavoriteBook({
        page: page,
        groupid:
          this.$router.currentRoute.query.id == 1
            ? ""
            : this.$router.currentRoute.query.id,
      });

      this.ebooks = res.data;
      this.paginate = {
        current_page: res.current_page,
        total: res.total,
        per_page: res.per_page,
      };
      this.ebooksDefault = this.ebooks;
    },
    async filterBook(id) {
      this.filterid = id;
      await this.getElibrary();
    },

    async getFlipbook(id) {
      if (!this.userData.id) {
        alert("ต้อง Login ก่อน");
        return;
      }

      const book = this.ebooks.find((e) => id == e.id);
      if (!book) return;

      // มีไฟล์ pdf เปิดอ่านด้วย FlipBook ได้
      // ถ้าไม่มี แปลว่าแนบมาเป็น .zip อ่านออนไลน์ไม่ได้ แสดงได้แค่ภาพหน้าปกที่อัปโหลดไว้
      if (!book.bookpdf) {
        this.coverImage = book.image;
        this.coverDownloadable = this.canDownload(book);
        this.coverOnly = true;
        this.dialog = true;
        return;
      }

      this.coverOnly = false;
      this.coverImage = null;
      this.dialog = true;

      // รอให้ container ถูกแสดงก่อน FlipBook จะวัดขนาดได้ถูกต้อง
      this.$nextTick(() => {
        // eslint-disable-next-line no-undef
        $(".flip-book-container").FlipBook({
          pdf: book.bookpdf,
          propertiesCallback: function (props) {
            props.page.depth *= 0.7;
            props.cover.padding = 0.002;
            return props;
          },
          controlsProps: {
            downloadURL: + book.bookpdf,
            actions: {
              cmdSmartPan: {
                enabled: true,
                enabledInNarrow: true,
              },
            },
          },
        });
      });
    },
    // เล่มที่แนบเป็น .zip อ่านออนไลน์ไม่ได้ กดแล้วเห็นแค่ภาพปก คำบนปุ่มจึงต้องไม่ใช่ "เปิดอ่าน"
    readLabel(book) {
      return book.bookpdf ? "เปิดอ่าน" : "เปิดตัวอย่าง";
    },
    // can_download เป็นธงของหนังสือว่าให้ดาวน์โหลดได้หรือไม่
    // API เก่าที่ยังไม่ส่งค่ามาให้ถือว่าดาวน์โหลดได้ เพื่อไม่ให้ปุ่มหายทั้งหน้า
    canDownload(book) {
      if (book.can_download === undefined || book.can_download === null) {
        return true;
      }
      return Boolean(Number(book.can_download));
    },
    downloadBook(id) {
      const book = this.ebooks.find((e) => id == e.id);
      if (!book) return;

      if (!this.canDownload(book)) {
        alert("คุณไม่มีสิทธิ์ดาวน์โหลดหนังสือเล่มนี้");
        return;
      }

      const bookUrl = book.bookpdf || book.bookzip;
      if (!bookUrl) {
        alert("ไม่พบไฟล์หนังสือเล่มนี้");
        return;
      }

      const downloadLink = document.createElement("a");
      downloadLink.href = bookUrl;
      downloadLink.download = bookUrl.split("/").pop();
      downloadLink.target = "_blank";
      downloadLink.style.display = "none";

      document.body.appendChild(downloadLink);
      downloadLink.click();

      document.body.removeChild(downloadLink);
    },
  },
};
</script>
<style scoped>
.coursesPage {
  height: 100%;
  min-height: 100vh;
}

.button {
  position: absolute;
  left: 80%;
}

.margin {
  padding: 10px;
}

.btn-right {
  text-align: right;
}

.paginate {
  float: right;
}

.solid-container {
  height: 100vh;
}

.book-actions {
  display: flex;
  gap: 12px;
}

.btn-book-read,
.btn-book-download {
  /* แบ่งความกว้างเท่ากันจนเต็มการ์ด เหลือปุ่มเดียวก็กินเต็มแถว */
  flex: 1 1 0;
  min-width: 0;
  border-radius: 12px !important;
  border: 2px solid #2a6db4 !important;
  padding: 8px 10px;
  font-weight: 500;
  white-space: nowrap;
}

.btn-book-read {
  background-color: #fff !important;
  color: #2a6db4 !important;
}

.btn-book-read:hover,
.btn-book-read:focus {
  background-color: #eaf1f9 !important;
  color: #21568d !important;
}

.btn-book-download {
  background-color: #2a6db4 !important;
  color: #fff !important;
}

.btn-book-download:hover,
.btn-book-download:focus {
  background-color: #21568d !important;
  border-color: #21568d !important;
}

.cover-only-container {
  text-align: center;
  padding: 20px 0;
}

.cover-only-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.cover-only-note {
  margin-top: 16px;
  color: #6c757d;
}

.modal {
  /* flex + margin:auto ที่ .modal-content ทำให้ popup อยู่กลางจอ
     และยังเลื่อนดูส่วนบนได้ถ้าเนื้อหาสูงเกินจอ */
  display: flex;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 20px 0;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

@media (max-width: 767px) {
  .container {
    padding: 0px;
  }
}

@media (min-width: 992px) {
  .modal-lg {
    max-width: auto !important;
  }
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: auto !important;
  }
}
.card{
  border-radius: 0px;
}
.card-img,
  .card-img-top {
    display: block;
    width: 100%;
    height: 573px !important;
    /* cover เพื่อให้ปกเต็มกรอบเสมอ ไม่เหลือขอบขาวเวลาสัดส่วนภาพไม่พอดี */
    object-fit: cover;
    object-position: center;
  }

.book-cover {
  width: 100%;
}

.book-cover .card {
  cursor: default;
  overflow: hidden;
  border: none;
}

/* การ์ดไม่มีเนื้อหาอื่นนอกจากรูป จึงไม่ต้องกันที่ให้ body */
.book-cover .card-body,
.book-cover .card-img-overlay {
  display: none;
}

</style>
